import React, { PureComponent, Fragment } from "react";
import { cdnUrl } from "@Utils/cdnHelper";
import "./style.scss";
// import * as Sentry from "@sentry/react";

class H3ErrorBoundaryApp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch = (error, info) => {
    this.setState({ error, info });
    // Sentry.captureException(error, { extra: info });
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleBack() {
    window.location.reload();
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <Fragment>
          <div className="error-outter-app">
            <div className="error-inner-app">
              <img src={cdnUrl("error.png", "icons")} width="220px" height="172.14px" />
              <div className="error-text"> {"Something went wrong"} </div>
              <div
                className="reload-button"
                onClick={() => this.handleBack()}
                type="primary"
                shape="round"
              >
                Reload
              </div>
            </div>
          </div>
        </Fragment>
      );
    }
    return children;
  }
}

export default H3ErrorBoundaryApp;
